const HOME_PAGE_NAME = "home";
const BLOG_PAGE_NAME = "blog";
const FAQ_PAGE_NAME = "faq";
const GAME_PAGE_NAME = "game";
const NOT_FOUND_PAGE_NAME = "not-found";
const POST_PAGE_NAME = "post";
const SERVERS_PAGE_NAME = "servers";
const SERVERS_TAC_PAGE_NAME = "servervs-tac";

const GEOBETA_PAGE_NAME = "geobeta";

export {
  HOME_PAGE_NAME,
  GEOBETA_PAGE_NAME,
  FAQ_PAGE_NAME,
  NOT_FOUND_PAGE_NAME,
  BLOG_PAGE_NAME,
  GAME_PAGE_NAME,
  POST_PAGE_NAME,
  SERVERS_PAGE_NAME,
  SERVERS_TAC_PAGE_NAME
};
